module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/Fagus/Kanagawa_Fagus_HadGEM2_RCP45_End.png";